import {
  IIntelligentRecommendationsEventTypeEnum,
  ISendIntelligentRecommendationsEventInput,
} from 'types/FMSGraphqlTypes'
import { IRecommendedShipmentFragment } from 'apps/fleet-planner/components/shipment/ShipmentCard/graphql/RecommendedShipmentFragment'
import { PER_PAGE } from '../constants'

interface IGetViewTrackingEventInput {
  recommendations: IRecommendedShipmentFragment[]
  page: number
}

export const getViewTrackingEventInput = ({
  page,
  recommendations,
}: IGetViewTrackingEventInput): ISendIntelligentRecommendationsEventInput => {
  const shipmentIds = recommendations.map(recs => Number(recs.shipmentId))
  const offset = page * PER_PAGE
  const shipmentOrder = shipmentIds.map((id, index) => index + offset + 1)
  return {
    intelligentRecsEventType: IIntelligentRecommendationsEventTypeEnum.view,
    shipmentIds,
    shipmentOrder,
  }
}
